import { Directive, Input } from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
  Validator,
  ValidatorFn,
} from '@angular/forms';

@Directive({
  selector: '[appDuplicatedValueValidator]',
  standalone: false,
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: DuplicatedValueValidatorDirective,
      multi: true,
    },
  ],
})
export class DuplicatedValueValidatorDirective implements Validator {
  @Input('appDuplicatedValueValidator') receivedData: string[] = [];

  validate(control: AbstractControl): ValidationErrors | null {
    return this.receivedData
      ? this.duplicatedValueValidator(this.receivedData)(control)
      : null;
  }

  duplicatedValueValidator(receivedData: string[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return receivedData.includes(control.value)
        ? { duplicatedValue: true }
        : null;
    };
  }
}
